import React, { useState } from "react";
import Applymodels from "../components/settings/model/Applymodels";
import { ToastContainer, toast } from 'react-toastify';

import { BASE_URL, FRONTEND_URL, IMAGE_URL } from "../config/axios";
import { NotificationToast, NotificationModal, PopUpNotificationModal } from "../components/Alerts/NotificationComponents";
import { useNavigate } from "react-router-dom";
import { ProfileProgressModal } from "../components/UserDetails/ProfileProgressComponent";
import { ShowBannerPopup, ShowBannerPopup2, ShowBannerPopup3 } from "../components/CustomFunctions";
import { Exit, SearchSmall } from "../components/AllSvg";
import { ShowBannerPopups } from "../components/settings/HRActivities/HRActivitiesComponents";
import { clearEncryptionKey } from "../utils/secureStorage";

const Dashboardnavbarcopy = ({ name, url }) => {
  const [openSearchBar, setOpenSearchBar] = useState(false);
  const handleSearchClick = () => {
    setOpenSearchBar(true);
  }

  return (
    // <div className="navbar-section-main scroll-fix-table-heading">
    <div className="navbar-section-main">
      <div className="navbar-margin-left flex-grow">
        <div className="navbar-subheading font-weight500 font-size-text">Pages / {url}</div>
        <div className="flex justify-between w-full">

          <div className="navbar-heading font-weight700 ">{name}</div>
          <div className="applymodel sm-visible">
            <Applymodels />
          </div>
        </div>
      </div>
      <ShowBannerPopups />
      <div className="navbar-subsection navbar-margin-right">
        <div className="applymodel all-visible">
          <Applymodels />
        </div>
        <div className="navbar-subsection-b">
          <div className="navbar-search flex-grow">
            <div onClick={handleSearchClick}>
              <SearchSmall />
            </div>
            {openSearchBar && (
              <div>
                <input placeholder="Search" className="navbar-input font-weight400 font-size-text " />
              </div>
            )}
          </div>

          <div className="navbar-logo-mobile">
            <PopUpNotificationModal />
            <button
              title="logout"
              className="navbar-svg"
              onClick={() => {
                toast.info('Loging Out...');
                clearEncryptionKey();
                localStorage.clear();
                sessionStorage.clear();
                window.location = FRONTEND_URL;
              }}>
              <Exit color={'#A3AED0'} />
            </button>
            <>
              <ProfileProgressModal />
            </>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboardnavbarcopy;